import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldEditorMapCropListComponent } from './field-editor-map-crop-list.component';
import {DxButtonModule, DxContextMenuModule, DxListModule, DxScrollViewModule, DxTabsModule} from 'devextreme-angular';



@NgModule({
  declarations: [FieldEditorMapCropListComponent],
  imports: [
    CommonModule,
    DxTabsModule,
    DxScrollViewModule,
    DxListModule,
    DxButtonModule,
    DxContextMenuModule
  ],
  exports: [FieldEditorMapCropListComponent]
})
export class FieldEditorMapCropListModule { }
